import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Footer from "../../../../footer";
import Header from "../../../../header/header";
import Navvbar from "../../../../header/Navvbar";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./editContactButton.css";

function EditContactButton() {
  const { accountId, contactId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    middleInitial: "",
    lastName: "",
    email: "",
    role: "Dental Hygienist",
    eBilling: false,
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Fetch contact data when component mounts
  useEffect(() => {
    const fetchContact = async () => {
      if (!contactId) return;

      try {
        setIsLoading(true);

        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/contacts/contact/${contactId}`
        );

        const contactData = response.data.data;

        setFormData({
          title: contactData.title || "",
          firstName: contactData.firstName || "",
          middleInitial: contactData.middleInitial || "",
          lastName: contactData.lastName || "",
          email: contactData.email || "",
          role: contactData.role || "Dental Hygienist",
          eBilling: contactData.eBilling || false,
        });
      } catch (error) {
        console.error("Error fetching contact:", error);
        alert("Failed to load contact data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchContact();
  }, [contactId]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleSaveClick = async () => {
    const newErrors = {
      firstName: !formData.firstName,
      lastName: !formData.lastName,
    };

    setErrors(newErrors);

    if (newErrors.firstName || newErrors.lastName) {
      alert("First Name and Last Name are required!");
      return;
    }

    setIsSaving(true);

    try {
      // Update the backend
      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/contacts/${contactId}`,
        formData
      );

      alert("Contact updated successfully!");

      navigate(`/TabsWorking/${accountId}`);
    } catch (error) {
      console.error("Error updating contact:", error);
      alert("Failed to update contact. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="edit-contact-loading">
        Loading contact data...
      </div>
    );
  }

  return (
    <>
      <Header />
      <Navvbar />

      <div className="edit-contact-page">
        <div className="edit-contact-layout">

          {/* Settings Sidebar */}
          <aside className="settings-sidebar">
            <h2>Settings</h2>

            <div className="settings-links">
              <a href="/Tabs">Lab Details</a>

              <a href="/">Store</a>

              <a href="/usersetting">Users</a>

              <a href="/">Permission Groups</a>

              <a href="/Account">Accounts</a>

              <a href="/Owerviews">Finances</a>

              <a href="/owersetting">Case Settings</a>
            </div>
          </aside>

          {/* Main Content */}
          <main className="edit-contact-content">
            <h3 className="edit-contact-title">
              {formData.firstName
                ? "Edit Contact"
                : "Edit Account Contact"}
            </h3>

            <h4 className="provider-details-title">
              Provider Details
            </h4>

            <div className="provider-details-box">
              <div className="contact-form-container">

                {/* Title */}
                <div className="contact-form-group">
                  <label htmlFor="title">
                    Title
                  </label>

                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    id="title"
                  />
                </div>

                {/* First Name */}
                <div className="contact-form-group">
                  <label htmlFor="firstName">
                    First Name
                    <span className="required-star">*</span>
                  </label>

                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    id="firstName"
                    className={
                      errors.firstName
                        ? "input-error"
                        : ""
                    }
                  />

                  {errors.firstName && (
                    <span className="error-message">
                      First name is required
                    </span>
                  )}
                </div>

                {/* Middle Initial */}
                <div className="contact-form-group">
                  <label htmlFor="middleInitial">
                    Middle Initial
                  </label>

                  <input
                    type="text"
                    name="middleInitial"
                    value={formData.middleInitial}
                    onChange={handleInputChange}
                    id="middleInitial"
                  />
                </div>

                {/* Last Name */}
                <div className="contact-form-group">
                  <label htmlFor="lastName">
                    Last Name
                    <span className="required-star">*</span>
                  </label>

                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    id="lastName"
                    className={
                      errors.lastName
                        ? "input-error"
                        : ""
                    }
                  />

                  {errors.lastName && (
                    <span className="error-message">
                      Last name is required
                    </span>
                  )}
                </div>

                {/* Email */}
                <div className="contact-form-group">
                  <label htmlFor="email">
                    Email
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    id="email"
                  />
                </div>

                {/* Role */}
                <div className="contact-form-group">
                  <label htmlFor="role">
                    Role
                  </label>

                  <select
                    name="role"
                    value={formData.role}
                    onChange={handleInputChange}
                    id="role"
                  >
                    <option value="Dental Hygienist">
                      Dental Hygienist
                    </option>

                    <option value="Dental Provider">
                      Dental Provider
                    </option>

                    <option value="Dental Student Provider">
                      Dental Student Provider
                    </option>

                    <option value="Dental Faculty Provider">
                      Dental Faculty Provider
                    </option>

                    <option value="Dental Assistant">
                      Dental Assistant
                    </option>

                    <option value="Clinic Director">
                      Clinic Director
                    </option>

                    <option value="Office Manager">
                      Office Manager
                    </option>

                    <option value="Front Desk">
                      Front Desk
                    </option>

                    <option value="BookKeeper">
                      BookKeeper
                    </option>

                    <option value="Practice Mini-Lab Technician">
                      Practice Mini-Lab Technician
                    </option>

                    <option value="Administrator">
                      Administrator
                    </option>
                  </select>
                </div>

                {/* E-Billing */}
                <div className="billing-group">
                  <label htmlFor="eBilling">
                    <input
                      type="checkbox"
                      name="eBilling"
                      id="eBilling"
                      checked={formData.eBilling}
                      onChange={handleInputChange}
                    />

                    <span>E-Billing</span>
                  </label>
                </div>

                {/* Buttons */}
                <div className="contact-form-buttons">
                  <Button
                    className="save-contact-button"
                    onClick={handleSaveClick}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save"}
                  </Button>

                  <Button
                    className="cancel-contact-button"
                    onClick={() =>
                      navigate(
                        `/account/${accountId}/contacts`
                      )
                    }
                  >
                    Cancel
                  </Button>
                </div>

              </div>
            </div>
          </main>
        </div>
      </div>

      <div className="edit-contact-footer">
        <Footer />
      </div>
    </>
  );
}

export default EditContactButton;